export interface DevicePreset {
  name: string;
  w: number;
  h: number;
}

export interface DeviceGroup {
  group: 'Phone' | 'Tablet';
  devices: DevicePreset[];
}

// Curated, portrait, in points. Kept LOCAL to the dashboard on purpose: the conformance VIEWPORTS
// array (packages/schemas) is phone-only by design and must not grow a tablet cell from here.
export const DEVICE_GROUPS: DeviceGroup[] = [
  {
    group: 'Phone',
    devices: [
      { name: 'iPhone SE', w: 320, h: 568 },
      { name: 'iPhone 8 Plus', w: 414, h: 736 },
      { name: 'iPhone 13/14', w: 390, h: 844 },
      { name: 'iPhone 15 Pro', w: 393, h: 852 },
      { name: 'iPhone 15 Pro Max', w: 430, h: 932 },
      { name: 'Pixel 8', w: 412, h: 732 },
      { name: 'Android Small', w: 360, h: 640 },
      { name: 'Android Large', w: 360, h: 800 },
    ],
  },
  {
    group: 'Tablet',
    devices: [
      { name: 'iPad mini', w: 744, h: 1133 },
      { name: 'iPad', w: 768, h: 1024 },
      { name: 'iPad Air', w: 820, h: 1180 },
      { name: 'iPad Pro 11"', w: 834, h: 1194 },
      { name: 'iPad Pro 12.9"', w: 1024, h: 1366 },
    ],
  },
];

/** The name of the preset matching these EXACT dimensions, or 'Custom'. Exact-match (not nearest) is
 *  deliberate — a nudged Width field should read 'Custom', exactly as the author left it. */
export function matchDevice(w: number, h: number): string {
  for (const group of DEVICE_GROUPS) {
    for (const device of group.devices) {
      if (device.w === w && device.h === h) return device.name;
    }
  }
  return 'Custom';
}
